import { apolloClient } from "@/plugins/vue-apollo.js";

const createBlock = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/blocks/create_block.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/blocks/block_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          }
        };
        let allBlocks = store.readQuery(query);
        allBlocks.getBlocks.blocks.unshift(data.createBlock.blocks[0]); //push to top
        store.writeQuery({
          ...query,
            data: allBlocks,
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createBlock };
